/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { createAsyncThunk } from "@reduxjs/toolkit";
import isEmpty from "lodash/fp/isEmpty";

import { MAPPED_AFNO } from "~/features/promoTools/constants";
import PromoToolsApi from "~/features/promoTools/PromoToolsApi";
import transformGetPromoToolsSites from "~/features/promoTools/transformers/transformGetPromoToolsSites";
import {
  PostCreateAfnoDetailsRequestBody,
  PostDeleteAfnoDetailsRequestBody,
  PostUpdateAfnoDetailsRequestBody,
} from "~/features/promoTools/types";

export const getPromoToolSitesAsync = createAsyncThunk("promoTool/getPromoToolSites", async () => {
  const response = await PromoToolsApi.getPromoToolsSites();

  const randomNumber = Math.random() * 99000;
  const randomTrackingId = Math.floor(randomNumber) + 1000;

  const sites = !isEmpty(response.data.result) ? transformGetPromoToolsSites.toSites(response.data) : [];
  const afno = sites[0]?.afnoDetails.find((detail) => detail.mapped === MAPPED_AFNO);
  const trackingId = afno ? afno.trackingId : randomTrackingId;

  return {
    trackingId: String(trackingId),
    randomTrackingId: String(randomTrackingId),
    sites: sites,
    ...(sites[0] && { selectedSite: sites[0] }),
  };
});

export const postCreateAfnoDetailsAsync = createAsyncThunk(
  "promoTool/postCreateAfnoDetails",
  async (payload: PostCreateAfnoDetailsRequestBody) => {
    const response = await PromoToolsApi.postCreateAfnoDetails(payload);

    return response.data;
  },
);

export const postUpdateAfnoDetailsAsync = createAsyncThunk(
  "promoTool/postUpdateAfnoDetails",
  async (payload: PostUpdateAfnoDetailsRequestBody) => {
    const response = await PromoToolsApi.postUpdateAfnoDetails(payload);

    return response.data;
  },
);

export const postDeleteAfnoDetailsAsync = createAsyncThunk(
  "promoTool/postDeleteAfnoDetails",
  async (payload: PostDeleteAfnoDetailsRequestBody) => {
    await PromoToolsApi.postDeleteAfnoDetails(payload);

    return true;
  },
);
